import React from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "../pages/landingPage";
import PrivateRoute from "../protectedRoute/PrivateRoute";
import PublicRoute from "../protectedRoute/publicRoute";
import LiveTest from "../pages/liveTest";
import Login from "../pages/login";
import CandidateSsoLogin from "../pages/candidateSsoLogin";
import Feedback from "../pages/feedback";
import SampleTest from "../pages/sampleTest";
import ExamSchedules from "../pages/examSchedules";
import PostExamUploadPage from "../pages/postExamUpload";
import PostExamUploadQrPage from "../pages/postExamUploadQr";
import ScreenShareInstruction from "../components/ScreenShareInstruction.tsx";
import SafeBrowserDownloadPage from "../pages/safeBrowserDownload";

export default function ExamRoutes() {
  return (
    <>
      <Routes>
        {/* <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} /> */}
        <Route path="/login" element={<Login />} />
        <Route path="/sso/login" element={<CandidateSsoLogin />} />

        <Route path="/home" element={<LandingPage />} />
        <Route path="/live-test" element={<PrivateRoute><LiveTest /></PrivateRoute>} />
        <Route path="/exam-schedules" element={<PrivateRoute><ExamSchedules /></PrivateRoute>} />
        <Route path="/feedback" element={<PrivateRoute><Feedback /></PrivateRoute>} />
        <Route path="/sample-test" element={<PrivateRoute><SampleTest /></PrivateRoute>} />
       
        <Route path="/post-exam-upload-qr" element={<PrivateRoute><PostExamUploadQrPage /></PrivateRoute>} />
        <Route path="/post-exam-upload" element={<PostExamUploadPage />} />
        <Route path="/screen-share-instructions" element={<ScreenShareInstruction />} />
 

        <Route path="/safe-browser/download" element={<SafeBrowserDownloadPage />} />

      </Routes>
    </>
  );
}
